import stripCommas from './stripCommas';

/**
 * @function findAppendix - Finds proper dollar marker (million, billion, trillion, etc) to append
 * @param {string} str - num-string
 * @return {string} Proper appendix or empty string
 * @example findAppendix(1,000,000) => 'M'
 */
const findAppendix = str => {
  const count = stripCommas(str).length;

  if (count > 12) return 'T';
  else if (count > 9) return 'B';
  else if (count > 6) return 'M';
  else if (count >= 4) return 'K';
  return '';
};

export default findAppendix;
